import RespostaRejeitada from './RespostaRejeitada';

export default RespostaRejeitada;
